import { useSyncExternalStore } from "react";

/**
 * A live media query as a boolean. External-store subscription (not state + effect): the first
 * render already has the right answer, so a gated subtree never mounts the wrong branch for a
 * frame and then throws it away.
 */
export const useMediaQuery = (query: string): boolean =>
  useSyncExternalStore(
    (onChange) => {
      if (typeof window === "undefined") return () => {};
      const mq = window.matchMedia(query);
      mq.addEventListener("change", onChange);
      return () => mq.removeEventListener("change", onChange);
    },
    () => typeof window !== "undefined" && window.matchMedia(query).matches,
    () => false
  );

/** Tailwind's `lg` — the desktop layouts (sidebar + content card, the top campaign pill). */
export const DESKTOP_QUERY = "(min-width: 1024px)";

export const useIsDesktop = (): boolean => useMediaQuery(DESKTOP_QUERY);
